module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/5-f2e1908180e88bf460118dd4d5c8318a.svg";